import { render } from "./CookiesPolicy.vue?vue&type=template&id=f619c54e&scoped=true"
import script from "./CookiesPolicy.vue?vue&type=script&lang=js"
export * from "./CookiesPolicy.vue?vue&type=script&lang=js"

import "./CookiesPolicy.vue?vue&type=style&index=0&id=f619c54e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f619c54e"]])

export default __exports__